// 修复单位审查#7：本文件原有 670 行，包含单位管理端 CRUD、统计、批量导入导出、订阅配额、
// 入驻引导等一整套 mock API。随着管理端与注册引导链路全部直连后端（services/organizationApi.ts、
// services/onboardingApi.ts 的 USE_MOCK 分支已删），这些假实现全部失去调用方，整体清除。
// 仅保留 loadFromStorage()：它是用户域 mock（mock/user.ts 用 orgId 反查单位名/状态、
// mock/user-settings.ts 校验加入申请的目标单位）仍在消费的种子数据读取，属他域依赖，不可删。
import { generateId, storageKey } from '@/services/types'
import type { Organization } from '@/types/organization'

const STORAGE_KEY = storageKey('organizations')

// Seed data
function createSeedOrganizations(): Organization[] {
  const now = new Date()
  const seeds: Organization[] = [
    {
      id: generateId(),
      name: '幸福街道办事处',
      type: 'township',
      region: '北京市朝阳区',
      contactName: '王建国',
      contactPhone: '13800138001',
      creditCode: '91110105MA0012345',
      status: 'normal',
      memberQuota: 20,
      memberCount: 8,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 30),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 2),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 2),
    },
    {
      id: generateId(),
      name: '阳光社区居委会',
      type: 'community',
      region: '上海市浦东新区',
      contactName: '李秀英',
      contactPhone: '13800138002',
      status: 'normal',
      memberQuota: 10,
      memberCount: 5,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 60),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 5),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 5),
    },
    {
      id: generateId(),
      name: '红星乡人民政府',
      type: 'township',
      region: '四川省成都市郫都区',
      contactName: '张志强',
      contactPhone: '13800138003',
      status: 'overdue',
      memberQuota: 20,
      memberCount: 12,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 90),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 10),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 7),
    },
    {
      id: generateId(),
      name: '碧水村村委会',
      type: 'village',
      region: '浙江省杭州市余杭区',
      contactName: '陈玉兰',
      contactPhone: '13800138004',
      status: 'normal',
      memberQuota: 5,
      memberCount: 3,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 15),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 1),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 12),
    },
    {
      id: generateId(),
      name: '鹏程科技有限公司',
      type: 'enterprise',
      region: '广东省深圳市南山区',
      contactName: '刘鹏飞',
      contactPhone: '13800138005',
      creditCode: '91440300MA5F12345',
      status: 'disabled',
      memberQuota: 50,
      memberCount: 0,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 120),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 20),
      lastActiveAt: undefined,
    },
    {
      id: generateId(),
      name: '和谐社会组织服务中心',
      type: 'social_org',
      region: '湖北省武汉市武昌区',
      contactName: '赵敏',
      contactPhone: '13800138006',
      status: 'normal',
      memberQuota: 10,
      memberCount: 6,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 45),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 3),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 1),
    },
    {
      id: generateId(),
      name: '东风街道办事处',
      type: 'township',
      region: '江苏省南京市鼓楼区',
      contactName: '孙伟',
      contactPhone: '13800138007',
      status: 'normal',
      memberQuota: 20,
      memberCount: 10,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 20),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 1),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 3),
    },
    {
      id: generateId(),
      name: '绿叶社区服务站',
      type: 'community',
      region: '重庆市渝中区',
      contactName: '周丽华',
      contactPhone: '13800138008',
      status: 'overdue',
      memberQuota: 5,
      memberCount: 4,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 80),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 8),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 2),
    },
    {
      id: generateId(),
      name: '金穗乡政府',
      type: 'township',
      region: '河南省郑州市新郑市',
      contactName: '吴刚',
      contactPhone: '13800138009',
      status: 'normal',
      memberQuota: 20,
      memberCount: 7,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 10),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 1),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 6),
    },
    {
      id: generateId(),
      name: '明湖村村委会',
      type: 'village',
      region: '山东省济南市历下区',
      contactName: '郑小红',
      contactPhone: '13800138010',
      status: 'normal',
      memberQuota: 5,
      memberCount: 2,
      createdAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 5),
      updatedAt: new Date(now.getTime() - 1000 * 60 * 60 * 24 * 1),
      lastActiveAt: new Date(now.getTime() - 1000 * 60 * 60 * 8),
    },
  ]
  return seeds
}

export function loadFromStorage(): Organization[] {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (raw) {
    try {
      const parsed = JSON.parse(raw)
      return parsed.map((item: any) => ({
        ...item,
        createdAt: new Date(item.createdAt),
        updatedAt: new Date(item.updatedAt),
        lastActiveAt: item.lastActiveAt ? new Date(item.lastActiveAt) : undefined,
      }))
    } catch {
      // fallthrough
    }
  }
  const seeds = createSeedOrganizations()
  saveToStorage(seeds)
  return seeds
}

function saveToStorage(items: Organization[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
}

